import Swiper from 'swiper';
import 'swiper/swiper-bundle.css';

;(function ($) {
  "use strict"
  $(function () {
    window.sliderCampCombo = function sliderCampCombo() {
      if ($(document).find('.x-combo-swiper').length) {
        let currentSwiperComboItem = 0,
          $currentItem = null;

        $(document).find(".x-combo-swiper .x-combo-swiper-item").each(function (index, el) {
          let $this = $(el);
          if ($this.find('.camp__link').hasClass('camp__link_active')) {
            currentSwiperComboItem = index;
            $currentItem = $this;
          }
        });

        let $catalogCombo = $('.x-combo-swiper');
        let swiperCombo = new Swiper('.x-combo-swiper .swiper-container', {
          direction: 'horizontal',
          freeMode: true,
          watchOverflow: true, // 	Когда включено, Swiper отключится и скроет навигационные кнопки, если на слайдах недостаточно слайдов
          slidesPerView: "auto",
          breakpoints: {
            420: {
              slidesPerView: 3,
            },
            640: {
              slidesPerView: 5,
            }
          },
          on: {
            touchEnd:function (){
              if (typeof window.reachMetricsGoal === typeof Function){
                window.reachMetricsGoal('mobile-combo-swiped');
              }
            },
            init: function () {
              let countShowSwiperCombo = 3,
                self = this;

              switch (this.currentBreakpoint) {
                case '640':
                  countShowSwiperCombo = 5;
                  break;
                case '420':
                  countShowSwiperCombo = 3;
                  break;
              }


              if (countShowSwiperCombo - 2 < currentSwiperComboItem) {
                this.slideTo(
                  currentSwiperComboItem - countShowSwiperCombo + 2,
                  0,
                  true
                );

                if (countShowSwiperCombo < 11) {
                  setTimeout(function () {

                    let screenMiddle = $(document).find('body').width() / 2,
                      itemOffset = $currentItem.offset().left,
                      itemWidth = $currentItem.width(),
                      deltaOffset = screenMiddle - itemOffset - itemWidth / 2,
                      offsetLastItem = $(document).find('.x-combo-swiper .x-combo-swiper-item:last-child').offset().left,
                      deltaOffsetLastItem = $(document).find('.header__content').width() - (offsetLastItem + itemWidth + deltaOffset);

                    if (deltaOffsetLastItem < 0) {
                      self.translateTo(self.getTranslate() + deltaOffset, 0, false, false);
                    }

                  }, 100);
                }
              }

              if (countShowSwiperCombo > 11) {
                setTimeout(function () {
                  $catalogCombo.css('opacity', 1);
                  $catalogCombo.removeClass('swiper-disable-transitions');
                }, 150);
              } else {
                setTimeout(function () {
                  $catalogCombo.css('opacity', 1);
                  $catalogCombo.removeClass('swiper-disable-transitions');
                }, 300);
              }
            }
          },
        });
      }
    }

    window.sliderCampCombo();

    if ($(document).find('.x-camp-swiper').length) {
      let currentSwiperCategoriesItem = 0,
        $currentItem = null;

      $(document).find(".x-camp-swiper .x-camp-swiper-item").each(function (index, el) {
        let $this = $(el);
        if ($this.find('.camp__link').hasClass('active')) {
          currentSwiperCategoriesItem = index;
          $currentItem = $this;
        }
      });

      let $catalogCategories = $('.x-camp-swiper');
      let swiperCategories = new Swiper('.x-camp-swiper .swiper-container', {
        direction: 'horizontal',
        freeMode: true,
        watchOverflow: true, // 	Когда включено, Swiper отключится и скроет навигационные кнопки, если на слайдах недостаточно слайдов
        slidesPerView: "auto",
        breakpoints: {
          420: {
            slidesPerView: 3,
          },
          640: {
            slidesPerView: 5,
          }
        },
        on: {
          init: function () {
            let countShowSwiperCategories = 3,
              self = this;

            switch (this.currentBreakpoint) {
              case '640':
                countShowSwiperCategories = 5;
                break;
              case '420':
                countShowSwiperCategories = 3;
                break;
            }

            if (countShowSwiperCategories - 2 < currentSwiperCategoriesItem) {
              this.slideTo(
                currentSwiperCategoriesItem - countShowSwiperCategories + 2,
                0,
                true
              );

              if (countShowSwiperCategories < 11) {
                setTimeout(function () {
                  let screenMiddle = $(document).find('body').width() / 2,
                    itemOffset = $currentItem.offset().left,
                    itemWidth = $currentItem.width(),
                    deltaOffset = screenMiddle - itemOffset - itemWidth / 2,
                    offsetLastItem = $(document).find('.x-camp-swiper .x-camp-swiper-item:last-child').offset().left,
                    deltaOffsetLastItem = $(document).find('.header__content').width() - (offsetLastItem + itemWidth + deltaOffset);

                  if (deltaOffsetLastItem < 0) {
                    self.translateTo(self.getTranslate() + deltaOffset, 0, false, false);
                  }

                }, 100);
              }
            }

            if (countShowSwiperCategories > 11) {
              setTimeout(function () {
                $catalogCategories.css('opacity', 1);
                $catalogCategories.removeClass('swiper-disable-transitions');
              }, 150);
            } else {
              setTimeout(function () {
                $catalogCategories.css('opacity', 1);
                $catalogCategories.removeClass('swiper-disable-transitions');
              }, 300);
            }
          }
        },
      });
    }
  })
})(jQuery)
